import axiosServise from "../ApiService";
import {News2} from "../../Entities/News2.ts";
import {NewsDetails} from "../../Entities/NewsDetails.ts";
import axios from "axios";


export async function Load_News(id) {
    // fetch("http://KhorshidPishva.com:8084/News/2", {
    //     "headers": {
    //         "accept": "application/json",
    //         "content-type": "application/json",
    //         "sec-ch-ua": "\"Not/A)Brand\";v=\"99\", \"Microsoft Edge\";v=\"115\", \"Chromium\";v=\"115\"",
    //         "sec-ch-ua-mobile": "?0",
    //         "sec-ch-ua-platform": "\"Windows\""
    //     },
    //     "referrer": "http://localhost:3000/",
    //     "referrerPolicy": "strict-origin-when-cross-origin",
    //     "body": "{\"Token\":\"1\",\"Entity\":{}}",
    //     "method": "POST",
    //     "mode": "cors",
    //     "credentials": "omit"
    // });
    //
    const axiosService2 = axios.create({
        baseURL: "http://KhorshidPishva.com:8084/",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
    // try {
    let responseData: News2
    await axiosService2.post(`News/?id=${id}`, {
        "Token": "1",
        "Entity": {}
    }).then(
        response => {
            responseData = response.data.response;
        })
    return responseData
}

export async function Save_News(news: News2) {
    const axiosService2 = axios.create({
        baseURL: "http://KhorshidPishva.com:8084/",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
    let responseData: News2
    await axiosService2.put(`News`, {
        "Token": "1",
        "Entity": news
    }).then(
        response => {
            responseData = response.data.response;
        })
    return responseData
}
